/**
 * @ Author: Housefolios
 * @ Create Time: 2021-09-16 13:21:50
 * @ Modified by: David Helmick
 * @ Modified time: 2025-10-23 14:50:04
 * @ Description: Main content of the contact agent dialog for non-RWN users
 */

import React, { useState, useEffect } from 'react'
// Centralized lodash imports - much cleaner!
import { map, find, isNil, isEmpty, truncate } from '@/utils/lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import withSession from '@/housefolios-components/Session/withSession'
import { useDropzone } from 'react-dropzone'

import {
  Grid,
  Button,
  Card,
  CardActions,
  Container,
  Divider,
  FormControlLabel,
  Step,
  Stepper,
  StepLabel,
  Typography,
  TextField,
  Checkbox,
  MenuItem,
  ListItem,
  List,
  Box,
} from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone'
import CloudUploadTwoToneIcon from '@mui/icons-material/CloudUploadTwoTone'
import { useMutation, useQuery } from '@apollo/client/react'
import BlockUi from 'react-block-ui'
import { PacmanLoader } from 'react-spinners'
import Check from '@mui/icons-material/Check'
import StepConnector from '@mui/material/StepConnector'
import {
  TextValidator,
  ValidatorForm,
} from '@/housefolios-components/shared/muiFormValidator'
import { CONTACT_AGENT } from '../mutations'
import { enqueueSnackbar } from 'notistack'
import { NumericFormat } from 'react-number-format'
import { GET_OPTIONS } from '../queries'
import Autocomplete from '@mui/material/Autocomplete'
import Alert from '@mui/material/Alert'
import { GET_PROPERTY } from '@/housefolios-components/PropertyContainer/queries'
import { faAddressBook } from '@fortawesome/free-regular-svg-icons'
import { wizardStepIconSx, wizardStepperTrackSx, wizardStepperSx, wizardPrimaryBtnSx } from '@/theme/skinSx'

function StepIcon(props) {
  const { active, completed } = props

  const icons = {
    1: (
      <FontAwesomeIcon icon={['fas', 'file-invoice-dollar']} sx={{ fontSize: "1.265rem !important" }} />
    ),
    2: <FontAwesomeIcon icon={['far', 'user']} />,
    3: <FontAwesomeIcon icon={['far', 'landmark']} />,
    4: <FontAwesomeIcon icon={['fal', 'paper-plane']} />,
  }

  return (
    <Box sx={wizardStepIconSx({ active, completed })}>
      {completed ? (
        <Check />
      ) : (
        icons[String(props.icon)]
      )}
    </Box>
  )
}

StepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  icon: PropTypes.node,
}

function getSteps() {
  // return ['Offer Details', 'Buyer Info', 'Funding Info', 'Review & Submit'];
  return ['Offer', 'Buyer', 'Funding', 'Review']
}

function ContactAgentStepperComponent(props) {
  const {
    session: {
      me: {
        // profile: { firstname = '', lastname = '' },
        // email = '',
        // phone = '',
        activeOrg,
      },
    },
    property: { _id, address = '', city = '', state = '', zip = '' },
  } = props

  const targetMarket = find(
    activeOrg.marketPlaces,
    (marketplace) => props.marketplace === marketplace.url,
  )
  let contactEmail = ''
  if (targetMarket && props.marketplace)
    contactEmail = targetMarket.contactEmail
  //const [imageUpload] = useMutation(IMAGE_UPLOAD)
  const [activeStep, setActiveStep] = useState(0)
  const [message, setMessage] = useState('')
  const [firstname, setFirstname] = useState(
    props.session.me.profile.firstname,
  )
  const [lastname, setLastname] = useState(
    props.session.me.profile.lastname,
  )
  const [email, setEmail] = useState(props.session.me.email)
  const [phone, setPhone] = useState(props.session.me.phone)
  const [offerPrice, setOfferPrice] = useState('')
  const [exchange1031, setExchange1031] = useState(false)
  const [buyer, setBuyer] = useState('')
  const [name, setName] = useState('')
  const [method, setMethod] = useState('')
  const [lender, setLender] = useState('')
  const [file, setFile] = useState()
  const steps = getSteps()

  useEffect(() => {
    setMessage('')
    setFirstname(props.session.me.profile.firstname)
    setLastname(props.session.me.profile.lastname)
    setEmail(props.session.me.email)
    setPhone(props.session.me.phone)
  }, [
    props.property,
    props.session.me.email,
    props.session.me.phone,
    props.session.me.profile.firstname,
    props.session.me.profile.lastname,
  ])

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }
  const [loader, setLoader] = useState(false)

  //const [addProperties] = useMutation(ADD_PROPERTIES)

  const [contactAgent] = useMutation(CONTACT_AGENT)

  const contact = () => {
    setLoader(true)
    contactAgent({
      variables: {
        message,
        propertyId: _id,
        contactEmail: [contactEmail],
        firstname,
        lastname,
        phone,
        email,
        address,
        city,
        state,
        zip,
        buyer,
        offerPrice: currencyFormat.format(offerPrice),
        exchange1031,
        title: name,
        funding: method,
        base64: file,
        makeOffer: !Boolean(props.marketplace),
      },
      refetchQueries: Boolean(props.marketplace)
        ? []
        : [
            {
              query: GET_PROPERTY,
              variables: { id: _id },
            },
          ],
    }).then(({ data  }) => {
      enqueueSnackbar(`Message sent successfully`, {
        variant: 'success',
        autoHideDuration: 3000,
      })
      setLoader(false)
      props.handleCloseAddComp()
    })
  }

  const {
    acceptedFiles,
    isDragActive,
    isDragAccept,
    isDragReject,
    getRootProps,
    getInputProps,
  } = useDropzone({
    maxFiles: 1,
    accept: {
      'image/*': [],
      'application/pdf': [],
    },
    onDrop: (acceptedFiles) => {
      const reader = new FileReader()
      reader.onload = async () => {
        const base64 = reader.result
        setFile(base64)
      }
      reader.readAsDataURL(acceptedFiles[0])
    },
  })

  // const handleNext = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep + 1);
  // };

  const currencyFormat = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })

  const buyerResults = useQuery(GET_OPTIONS, {
    variables: { name: 'buyer' },
  })
  const buyerLoading = buyerResults.loading || false
  const buyerError = buyerResults.error || null
  const buyerOptions = buyerResults.data
    ? buyerResults.data.options.options
    : []

  const methodResults = useQuery(GET_OPTIONS, {
    variables: { name: 'method' },
    skip: activeStep < 2,
  })
  const methodLoading = methodResults.loading || false
  const methodError = methodResults.error || null
  const methodOptions = methodResults.data
    ? methodResults.data.options.options
    : []

  const lenderResults = useQuery(GET_OPTIONS, {
    variables: { name: 'lender' },
    skip: activeStep < 2,
  })
  const lenderLoading = lenderResults.loading || false
  const lenderError = lenderResults.error || null
  const lenderOptions = lenderResults.data
    ? lenderResults.data.options.options
    : []

  if (
    buyerLoading ||
    (activeStep >= 2 && (methodLoading || lenderLoading))
  ) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 240,
          padding: 48,
        }}
      >
        <PacmanLoader color={'var(--primary)'} loading={true} />
      </div>
    )
  }
  if (buyerError) return buyerError.message
  if (methodError) return methodError.message
  if (lenderError) return lenderError.message

  const files = acceptedFiles.map((file) => (
    <ListItem key={file.path} sx={[{ px: '1rem', py: '0.5rem', color: '#368cff', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }, { fontSize: "0.875rem !important" }]}>
      <span>{file.path}</span>{' '}
      <Box
        component="span"
        data-hf="file-size"
        sx={{
          display: "inline-block",
          py: 0,
          px: "0.7em",
          fontSize: "70%",
          fontWeight: 700,
          lineHeight: "21px",
          textAlign: "center",
          whiteSpace: "nowrap",
          verticalAlign: "baseline",
          borderRadius: 0,
          textTransform: "uppercase",
          height: 20,
          pr: "0.85em",
          pl: "0.85em",
          backgroundColor: "rgb(100%, 98.5067873303%, 94.7058823529%) !important",
          color: "#f4772e",
        }}
        >
        {file.size} bytes
      </Box>
    </ListItem>
  ))

  const column1 = [
    // {
    //   type: 'double',
    //   left1: 'Address',
    //   left2: 'City, state, zip',
    //   right1: address,
    //   right2: `${city}, ${state} ${zip}`,
    //   divider: 'true',
    // },
    {
      left1: 'Offer',
      right1: currencyFormat.format(offerPrice),
      divider: 'true',
    },
    {
      left1: 'Funding',
      right1: find(methodOptions, (option) => option.value === method)
        ? find(methodOptions, (option) => option.value === method)
            .label
        : '',
      divider: 'true',
    },
    {
      // type: 'double',
      left1: 'Proof of Funds',
      left2: 'File name',
      right1: 'Uploaded',
      right2: !isEmpty(acceptedFiles)
        ? truncate(acceptedFiles[0].name)
        : '',
      divider: 'true',
    },
    {
      type: 'double',
      left1: 'Buyer',
      left2: 'Email',
      right1: find(buyerOptions, (option) => option.value === buyer)
        ? find(buyerOptions, (option) => option.value === buyer).label
        : '',
      right2: email,
      divider: 'true',
    },
    {
      left1: 'Phone',
      right1: phone,
      // divider: 'true',
    },
  ]

  // const column2 = [
  //   {
  //     type: 'double',
  //     left1: 'Buyer',
  //     left2: 'Email',
  //     right1: find(buyerOptions, option => option.value === buyer) ? find(buyerOptions, option => option.value === buyer).label : '',
  //     right2: email,
  //     divider: 'true',
  //   },
  //   {
  //     left1: 'Phone',
  //     right1: phone,
  //     divider: 'true',
  //   },
  //   {
  //     type: 'double',
  //     left1: 'Address',
  //     left2: 'City, state, zip',
  //     right1: address,
  //     right2: `${city}, ${state} ${zip}`
  //   },
  // ]

  const isDisabled =
    activeStep === 0
      ? isNil(offerPrice) || !buyer
      : activeStep === 1
        ? !name ||
          !firstname ||
          !lastname ||
          !phone ||
          !email ||
          !message
        : activeStep === 2
          ? !method || !file
          : false

  return (
    <BlockUi
      blocking={loader}
      loader={
        <PacmanLoader color={'var(--primary)'} loading={true} />
      }
      message={<Box sx={{ color: '#368cff' }}>Sending Message</Box>}
    >
      <ValidatorForm>
        <Card variant="outlined">
          <div>
            <Box data-hf="wizard-stepper-track" sx={wizardStepperTrackSx}>
              <Stepper style={{ padding: 24 }} alternativeLabel activeStep={activeStep} connector={<StepConnector />} sx={wizardStepperSx}>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel
                      slots={{
                        stepIcon: StepIcon,
                      }}
                    >
                      {label}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
            <span>
              <div /*style={{ maxHeight: window.innerHeight - 300 }}*/
              >
                {activeStep === 0 && (
                  <Container>
                    <Grid
                      container
                      direction="row"
                      spacing={2}
                      style={{ marginTop: 25 }}
                    >
                      <Grid size={12}>
                        <Typography
                          variant="h5"
                          style={{ fontWeight: 600 }}
                        >
                          Offer Details
                        </Typography>
                      </Grid>
                      <Grid size={12}>
                        <Typography variant="subtitle1">
                          Please fill out the fields below to
                          continue.
                        </Typography>
                      </Grid>
                      <Grid size={{ sm: 6 }}>
                        <NumericFormat
                          customInput={TextField}
                          thousandSeparator={true}
                          prefix={'$'}
                          fullWidth={true}
                          autoFocus
                          decimalScale={0}
                          key="offerPrice"
                          name="offerPrice"
                          value={offerPrice || ''}
                          onValueChange={(values) => {
                            const { value } = values
                            setOfferPrice(Number(value))
                            // const event = {
                            //   target: {
                            //     name: 'offerPrice',
                            //     value: value,
                            //     type: 'number',
                            //   },
                            //   preventDefault: () => {
                            //     return null
                            //   },
                            // }
                            // onChange(event)
                          }}
                          type={'text'}
                          onFocus={(event) => {
                            event.target.select()
                          }}
                          variant="outlined"
                          margin="dense"
                          label="Offer Price"
                          helperText={`Asking price is ${
                            props.property.acquisition
                              ? currencyFormat.format(
                                  props.property.acquisition
                                    ? props.property.acquisition
                                        .analysis.listPrice
                                    : 0,
                                )
                              : '-'
                          }`}
                        />
                      </Grid>
                      <Grid size={{ sm: 6 }}>
                        <TextField
                          select
                          variant="outlined"
                          margin="dense"
                          fullWidth={true}
                          value={buyer || ''}
                          onChange={(event) =>
                            setBuyer(event.target.value)
                          }
                          label="Buyer is"
                        >
                          {map(buyerOptions, (option) => (
                            <MenuItem
                              key={option.value}
                              value={option.value}
                            >
                              {option.label}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid size={12}>
                        <Grid
                          container
                          wrap="nowrap"
                          sx={{
                            alignItems: 'center',
                          }}
                        >
                          <Grid>
                            <FormControlLabel
                              color="primary"
                              label="This will be part of a 1031 exchange"
                              labelPlacement="end"
                              control={<Checkbox />}
                              checked={exchange1031}
                              onClick={() => {
                                setExchange1031(!exchange1031)
                              }}
                            />
                          </Grid>
                          {/* <Grid style={{ paddingLeft: 5 }}>
                            <Typography>This will be part of a 1031 exchange</Typography>
                          </Grid> */}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Container>
                )}
                {activeStep === 1 && (
                  <Container>
                    <Grid
                      container
                      direction="row"
                      spacing={2}
                      style={{ marginTop: 25 }}
                    >
                      <Grid size={12}>
                        <Typography
                          variant="h5"
                          style={{ fontWeight: 600 }}
                        >
                          Buyer Information
                        </Typography>
                      </Grid>
                      <Grid size={12}>
                        <Typography variant="subtitle1">
                          Please fill out the fields below to
                          continue.
                        </Typography>
                      </Grid>
                      <Grid size={12}>
                        <TextValidator
                          fullWidth
                          variant="outlined"
                          // margin='dense'
                          label="Name to appear on title"
                          helperText="Please write the name exactly as you wish it to appear on the title"
                          autoFocus
                          value={name}
                          onChange={(event) =>
                          setName(event.target.value)
                          }
                          required={true}
                          validators={[
                          'required',
                          'maxStringLength: 50',
                          ]}
                          errorMessages={[
                          'This field is required',
                          'You cannot exceed 50 characters',
                          ]}
                          slotProps={{
                          formHelperText: {
                          style: {
                          color: '#368CFF',
                          },
                          },
                          }}
                          />
                      </Grid>
                      <Grid size={{ sm: 6 }}>
                        <TextValidator
                          fullWidth
                          variant="outlined"
                          // margin='dense'
                          label="First Name"
                          value={firstname}
                          onChange={(event) =>
                            setFirstname(event.target.value)
                          }
                          required={true}
                          validators={[
                            'required',
                            'maxStringLength: 20',
                            'matchRegexp:^[A-z ]+$',
                          ]}
                          errorMessages={[
                            'This field is required',
                            'You cannot exceed 20 characters',
                            'This field only allows characters in the alphabet and spaces',
                          ]}
                        />
                      </Grid>
                      <Grid size={{ sm: 6 }}>
                        <TextValidator
                          fullWidth
                          variant="outlined"
                          // margin='dense'
                          label="Last Name"
                          value={lastname}
                          onChange={(event) =>
                            setLastname(event.target.value)
                          }
                          required={true}
                          validators={[
                            'required',
                            'maxStringLength: 20',
                            'matchRegexp:^[A-z ]+$',
                          ]}
                          errorMessages={[
                            'This field is required',
                            'You cannot exceed 20 characters',
                            'This field only allows characters in the alphabet and spaces',
                          ]}
                        />
                      </Grid>
                      <Grid size={{ sm: 6 }}>
                        <TextValidator
                          fullWidth
                          variant="outlined"
                          // margin='dense'
                          label="Email Address"
                          value={email}
                          onChange={(event) =>
                            setEmail(event.target.value)
                          }
                          required={true}
                          validators={[
                            'required',
                            'maxStringLength: 50',
                            'isEmail',
                          ]}
                          errorMessages={[
                            'This field is required',
                            'You cannot exceed 50 characters',
                            'Not a valid email address',
                          ]}
                        />
                      </Grid>
                      <Grid size={{ sm: 6 }}>
                        <TextValidator
                          fullWidth
                          variant="outlined"
                          // margin='dense'
                          label="Phone"
                          value={phone}
                          onChange={(event) =>
                            setPhone(event.target.value)
                          }
                          required={true}
                          validators={[
                            'required',
                            'matchRegexp:^[0-9()-]+$',
                          ]}
                          errorMessages={[
                            'This field is required',
                            'Not a valid phone number',
                          ]}
                        />
                      </Grid>
                      <Grid size={12}>
                        <TextValidator
                          fullWidth
                          variant="outlined"
                          // margin='dense'
                          label="Comments"
                          value={message}
                          onChange={(event) =>
                            setMessage(event.target.value)
                          }
                          required={true}
                          multiline={true}
                          rows={4}
                          validators={[
                            'required',
                            'maxStringLength: 3000',
                          ]}
                          errorMessages={[
                            'This field is required',
                            'You cannot exceed 3000 characters',
                          ]}
                        />
                      </Grid>
                    </Grid>
                  </Container>
                )}
                {activeStep === 2 && (
                  <Container>
                    {/* ******* Cash Purchase ******* */}
                    {/* <Grid container direction="row" spacing={2} style={{ marginTop: 25 }}>
                      <Grid size={12}>
                        <Typography variant='h5' style={{ fontWeight: 600}}>Funding Information</Typography>
                      </Grid>
                      <Grid size={12}>
                        <Typography variant='subtitle1'>Please fill out the fields below to continue.</Typography>
                      </Grid>
                      <Grid size={12}>
                        <TextField
                          variant='outlined'
                          margin='dense'
                          fullWidth={true}
                          label="Method of Funding"
                        />
                      </Grid>
                    </Grid>
                    <Divider style={{ marginTop: 25, marginBottom: 25 }} />
                    <Grid container>
                      <Grid size={12}>
                        <Typography variant='h5' style={{ fontWeight: 600}}>Pre-approval letter / Proof of funds</Typography>
                      </Grid>
                      <Grid size={12}>
                        <Typography variant='subtitle1'>Please add one more file below to continue.</Typography>
                      </Grid>
                      <Grid size={12}>
                        <div>
                          <Box
                            {...getRootProps()} sx={{
                              position: "relative",
                              display: "flex",
                              flexDirection: "column",
                              outline: "none !important",
                              "& *": { outline: "none !important" },
                            }}>
                            <input {...getInputProps()} />
                            <div>
                              {isDragAccept && (
                                <div>
                                  <div
                                    style={{
                                      marginBottom: '1rem',
                                      backgroundColor: '#1bc943',
                                      color: '#fff',
                                    }}
                                  >
                                    <CheckIcon />
                                  </div>
                                  <div>
                                    We're ready to start!
                                  </div>
                                </div>
                              )}
                              {isDragReject && (
                                <div>
                                  <div
                                    style={{
                                      marginBottom: '1rem',
                                      backgroundColor: '#f83245',
                                      color: '#fff',
                                    }}
                                  >
                                    <CloseTwoToneIcon />
                                  </div>
                                  <div>
                                    These files are not images!
                                  </div>
                                </div>
                              )}
                              {!isDragActive && (
                                <div>
                                  <div
                                    style={{
                                      marginBottom: '1rem',
                                      backgroundColor: '#fff',
                                      color: '#4191ff',
                                    }}
                                  >
                                    <CloudUploadTwoToneIcon />
                                  </div>
                                  <div>
                                    Drag and drop images here
                                  </div>
                                </div>
                              )}
                              <small
                                style={{
                                  paddingTop: '0.5rem',
                                  paddingBottom: '0.5rem',
                                }}
                              >
                                or
                              </small>
                              <div>
                                <Button
                                  sx={{ fontWeight: 700, px: '1.5rem' }}
                                >
                                  <span style={{ paddingLeft: '0.5rem', paddingRight: '0.5rem' }}>
                                    Browse Files
                                  </span>
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Grid>
                    </Grid> */}

                    {/* ******* Financing ******* */}
                    <Grid
                      container
                      direction="row"
                      spacing={2}
                      style={{ marginTop: 25 }}
                    >
                      <Grid size={12}>
                        <Typography
                          variant="h5"
                          style={{ fontWeight: 600 }}
                        >
                          Funding Information
                        </Typography>
                      </Grid>
                      <Grid size={12}>
                        <Typography variant="subtitle1">
                          Please fill out the fields below to
                          continue.
                        </Typography>
                      </Grid>
                      <Grid size={12}>
                        <TextField
                          select
                          variant="outlined"
                          margin="dense"
                          value={method || ''}
                          onChange={(event) =>
                            setMethod(event.target.value)
                          }
                          fullWidth={true}
                          label="Method of Funding"
                        >
                          {map(methodOptions, (option) => (
                            <MenuItem
                              key={option.value}
                              value={option.value}
                            >
                              {option.label}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      {method !== 'Cash' && (
                        <Grid size={12}>
                          {/* <Autocomplete
                            freeSolo
                            inputValue={lender}
                            //value={lender}
                            options={lenderOptions}
                            getOptionLabel={(option) => option.label}
                            //onChange={(event, newValue) => setLender(newValue)}
                            onInputChange={(event, newValue) => setLender(newValue)}
                            renderInput={(params) => <TextField {...params} label="Name of Lender" variant="outlined" margin='dense' />}
                          /> */}
                          <TextField
                            value={lender}
                            onChange={(event) =>
                              setLender(event.target.value)
                            }
                            variant="outlined"
                            margin="dense"
                            fullWidth={true}
                            label="Name of Lender"
                          />
                        </Grid>
                      )}
                    </Grid>
                    <Divider
                      style={{ marginTop: 25, marginBottom: 25 }}
                    />
                    <Grid container>
                      <Grid size={12}>
                        <Typography
                          variant="h5"
                          style={{ fontWeight: 600 }}
                        >
                          Pre-approval letter / Proof of funds
                        </Typography>
                      </Grid>
                      <Grid size={12}>
                        <Typography variant="subtitle1">
                          Please add one more file below to continue.
                        </Typography>
                      </Grid>
                      <Grid size={12}>
                        <Box data-hf="dropzone" sx={{
                          "html[data-color-mode=\"dark\"] &": { backgroundColor: "#2a2a2a !important", borderColor: "rgba(255, 255, 255, 0.28) !important", color: "rgba(255, 255, 255, 0.7) !important" },
                        }}>
                          <Box
                            {...getRootProps()} sx={{
                              position: "relative",
                              display: "flex",
                              flexDirection: "column",
                              outline: "none !important",
                              "& *": { outline: "none !important" },
                            }}
                          >
                            <input {...getInputProps()} />
                            <Box data-hf="dropzone-inner" sx={{
                              padding: "3rem 1rem",
                              cursor: "pointer",
                              transition: "all 0.2s ease-in-out",
                              textAlign: "center",
                              color: "#a6a6b9",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                              border: "2px dashed #e6e7f1",
                              borderRadius: "0.65rem",
                              backgroundColor: "#f8f9ff",
                              "&:hover": { borderColor: "#a6a6b9", color: "#4f5062", background: "#f8f9ff" },
                              "html[data-color-mode=\"dark\"] &": { backgroundColor: "#2a2a2a !important", borderColor: "rgba(255, 255, 255, 0.28) !important", color: "rgba(255, 255, 255, 0.7) !important" },
                              "html[data-color-mode=\"dark\"] &:hover": { borderColor: "#368cff !important", color: "rgba(255, 255, 255, 0.87) !important", backgroundColor: "#333 !important" },
                              background: "transparent",
                              borderColor: "transparent",
                              borderWidth: "1px",
                            }}>
                              {isDragAccept && (
                                <div>
                                  <Box sx={[{
                                    height: "100px !important",
                                    width: "100px !important",
                                    lineHeight: "100px !important",
                                    display: "inline-flex !important",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    p: 0,
                                    border: 0,
                                    transition: "all 0.2s ease-in-out !important",
                                    transform: "scale(1) !important",
                                    boxShadow: "none",
                                    position: "relative",
                                    zIndex: "0",
                                    "&:hover": { borderRadius: "0.65rem", transform: "scale(1.08)", zIndex: 3 },
                                    mb: "1rem",
                                    backgroundColor: "#1bc943",
                                    borderRadius: "0.75rem",
                                    color: "#fff",
                                  }, { boxShadow: "0 0.46875rem 2.1875rem rgba(27, 201, 67, 0.03), 0 0.9375rem 1.40625rem rgba(27, 201, 67, 0.03), 0 0.25rem 0.53125rem rgba(27, 201, 67, 0.05), 0 0.125rem 0.1875rem rgba(27, 201, 67, 0.03) !important" }]}>
                                    <CheckIcon  sx={{
                                      height: "50px !important",
                                      width: "50px !important",
                                      lineHeight: "50px !important",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      p: 0,
                                    }}/>
                                  </Box>
                                  <Box sx={[{ color: '#1bc943' }, { fontSize: "0.8333333333rem !important" }]}>
                                    We're ready to start!
                                  </Box>
                                </div>
                              )}
                              {isDragReject && (
                                <div>
                                  <Box sx={[{
                                    height: "100px !important",
                                    width: "100px !important",
                                    lineHeight: "100px !important",
                                    display: "inline-flex !important",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    p: 0,
                                    border: 0,
                                    transition: "all 0.2s ease-in-out !important",
                                    transform: "scale(1) !important",
                                    boxShadow: "none",
                                    position: "relative",
                                    zIndex: "0",
                                    "&:hover": { borderRadius: "0.65rem", transform: "scale(1.08)", zIndex: 3 },
                                    mb: "1rem",
                                    backgroundColor: "#f83245",
                                    borderRadius: "0.75rem",
                                    color: "#fff",
                                  }, { boxShadow: "0 0.46875rem 2.1875rem rgba(248, 50, 69, 0.03), 0 0.9375rem 1.40625rem rgba(248, 50, 69, 0.03), 0 0.25rem 0.53125rem rgba(248, 50, 69, 0.05), 0 0.125rem 0.1875rem rgba(248, 50, 69, 0.03) !important" }]}>
                                    <CloseTwoToneIcon  sx={{
                                      height: "50px !important",
                                      width: "50px !important",
                                      lineHeight: "50px !important",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      p: 0,
                                    }}/>
                                  </Box>
                                  <Box sx={[{ color: '#f83245' }, { fontSize: "0.8333333333rem !important" }]}>
                                    These files are not images!
                                  </Box>
                                </div>
                              )}
                              {!isDragActive && (
                                <div>
                                  <Box sx={[{
                                    height: "90px !important",
                                    width: "90px !important",
                                    lineHeight: "90px !important",
                                    display: "inline-flex !important",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    p: 0,
                                    border: 0,
                                    transition: "all 0.2s ease-in-out !important",
                                    transform: "scale(1) !important",
                                    boxShadow: "none",
                                    position: "relative",
                                    zIndex: "0",
                                    "&:hover": { borderRadius: "0.65rem", transform: "scale(1.08)", zIndex: 3 },
                                    mb: "1rem",
                                    backgroundColor: "#fff",
                                    borderRadius: "0.75rem",
                                  }, { boxShadow: "0 0.46875rem 2.1875rem rgba(244, 245, 253, 0.03), 0 0.9375rem 1.40625rem rgba(244, 245, 253, 0.03), 0 0.25rem 0.53125rem rgba(244, 245, 253, 0.05), 0 0.125rem 0.1875rem rgba(244, 245, 253, 0.03) !important" }]} style={{ color: '#4191ff' }}>
                                    <CloudUploadTwoToneIcon  sx={{
                                      height: "40px !important",
                                      width: "40px !important",
                                      lineHeight: "40px !important",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      p: 0,
                                    }}/>
                                  </Box>
                                  <Box sx={{ fontSize: "0.875rem !important" }}>
                                    Drag and drop images here
                                  </Box>
                                </div>
                              )}
                              <Box
                                component="small"
                                data-hf="muted"
                                sx={{
                                  py: '0.5rem',
                                  color: 'rgba(7, 9, 25, 0.5)',
                                  'html[data-color-mode="dark"] &': {
                                    color: 'rgba(255, 255, 255, 0.68) !important',
                                  },
                                }}
                              >
                                or
                              </Box>
                              <div>
                                <Button
                                  sx={{
                                    boxShadow: "0 0.25rem 0.55rem rgba(54, 140, 255, 0.35)",
                                    color: "#fff",
                                    backgroundColor: "#368cff",
                                    backgroundImage: "none",
                                    borderColor: "#368cff",
                                    "&:not(:disabled):hover": { backgroundColor: "#368cff", color: "#fff" },
                                    "&:not(:disabled).active, &:not(:disabled).active:hover, &:not(:disabled):active": { backgroundColor: "#036fff" },
                                    "&:not(:disabled):active": { boxShadow: "0 0.22rem 0.525rem rgba(54, 140, 255, 0.4), 0 0.0625rem 0.385rem rgba(54, 140, 255, 0.54)" },
                                    "&:not(:disabled).active .btn-wrapper--icon svg path, &:hover .btn-wrapper--icon svg path": { fill: "#fff" },
                                    "html[data-color-mode=\"dark\"] &": { color: "#fff !important" },
                                    transition: "all 0.2s ease-in-out !important",
                                    transform: "scale(1) !important",
                                    position: "relative",
                                    zIndex: "0",
                                    "&:hover": { transform: "scale(1.08)", zIndex: 3 },
                                    borderRadius: "4.5rem",
                                    fontWeight: 700,
                                    px: "1.5rem",
                                  }}
                                  >
                                  <Box
                                    component="span"
                                    sx={{ px: '0.5rem' }}
                                  >
                                    Browse Files
                                  </Box>
                                </Button>
                              </div>
                            </Box>
                          </Box>
                        </Box>
                        <div>
                          {files.length <= 0 ? (
                            <Box sx={[{ color: '#11c5db', textAlign: 'center', my: '1.5rem', }, { fontSize: "0.875rem !important" }]}>
                              Uploaded file will appear here!
                            </Box>
                          ) : (
                            <Box sx={[{ fontWeight: 700, my: '1.5rem', textTransform: 'uppercase', color: '#4f5062', textAlign: 'center', }, { fontSize: "0.875rem !important" }]}>
                              Uploaded File
                            </Box>
                          )}
                          {files.length > 0 && (
                            <div>
                              <Alert
                                severity="success"
                                sx={{
                                textAlign: 'center',
                                mb: '1rem',
                                }}
                                >
                                You have uploaded{' '}
                                <b>{files.length}</b> file!
                              </Alert>
                              <List component="div" sx={{ fontSize: "0.875rem !important" }}>
                                {files}
                              </List>
                            </div>
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  </Container>
                )}
                {activeStep === 3 && (
                  <Container>
                    <Grid
                      container
                      direction="row"
                      /*spacing={2}*/ style={{ marginTop: 25 }}
                    >
                      <Grid size={12}>
                        <Typography
                          variant="h5"
                          style={{ fontWeight: 600 }}
                        >
                          Review & Submit
                        </Typography>
                      </Grid>
                      <Grid size={12} style={{ marginBottom: 25 }}>
                        <Typography variant="subtitle1">
                          Please verify all the information below is
                          correct before submitting.
                        </Typography>
                      </Grid>
                      <Grid size={12} style={{ marginBottom: 50 }}>
                        <Card
                          style={{
                            padding: 25,
                            borderTopRightRadius: 0,
                            borderBottomRightRadius: 0,
                            borderColor: 'black',
                            borderWidth: 1,
                          }}
                        >
                          <Grid container direction="column">
                            <Grid>
                              <Grid
                                container
                                direction="column"
                                style={{ whiteSpace: 'nowrap' }}
                                sx={{
                                  alignItems: 'center',
                                }}
                              >
                                <Grid data-hf-grid="keep">
                                  <Typography
                                    variant="h6"
                                    style={{ fontWeight: 600 }}
                                  >
                                    {address}
                                  </Typography>
                                </Grid>
                                <Grid data-hf-grid="keep">
                                  <Typography
                                    variant="subtitle2"
                                    style={{
                                      textAlign: 'right',
                                      color: '#9198a8',
                                    }}
                                  >{`${city}, ${state} ${zip}`}</Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Divider style={{ marginTop: 15 }} />
                            {map(column1, (section, index) =>
                              section.type !== 'double' ? (
                                <span key={section.left1 || `col1-${index}`}>
                                  <Grid>
                                    <Grid
                                      container
                                      style={{ height: 70 }}
                                      sx={{
                                        justifyContent:
                                          'space-between',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <Grid data-hf-grid="keep">
                                        <Typography
                                          variant="h6"
                                          style={{ fontWeight: 600 }}
                                        >
                                          {section.left1}
                                        </Typography>
                                      </Grid>
                                      <Grid data-hf-grid="keep">
                                        <Typography
                                          variant="h6"
                                          style={{
                                            textAlign: 'right',
                                            fontWeight: 600,
                                          }}
                                        >
                                          {section.right1}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  {section.divider === 'true' && (
                                    <Divider />
                                  )}
                                </span>
                              ) : (
                                <span key={`${section.left1 || 'col1'}-double-${index}`}>
                                  <Grid>
                                    <Grid
                                      container
                                      style={{
                                        height: 70,
                                        whiteSpace: 'nowrap',
                                      }}
                                      sx={{
                                        justifyContent:
                                          'space-between',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <Grid data-hf-grid="keep">
                                        <Grid
                                          container
                                          direction="column"
                                          style={{
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          <Grid data-hf-grid="keep">
                                            <Typography
                                              variant="h6"
                                              style={{
                                                fontWeight: 600,
                                              }}
                                            >
                                              {section.left1}
                                            </Typography>
                                          </Grid>
                                          <Grid data-hf-grid="keep">
                                            <Typography
                                              variant="subtitle2"
                                              style={{
                                                color: '#9198a8',
                                              }}
                                            >
                                              {section.left2}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                      <Grid data-hf-grid="keep">
                                        <Grid
                                          container
                                          direction="column"
                                          style={{
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          <Grid data-hf-grid="keep">
                                            <Typography
                                              variant="h6"
                                              style={{
                                                textAlign: 'right',
                                                fontWeight: 600,
                                              }}
                                            >
                                              {section.right1}
                                            </Typography>
                                          </Grid>
                                          <Grid data-hf-grid="keep">
                                            <Typography
                                              variant="subtitle2"
                                              style={{
                                                textAlign: 'right',
                                                color: '#9198a8',
                                              }}
                                            >
                                              {section.right2}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  {section.divider === 'true' && (
                                    <Divider />
                                  )}
                                </span>
                              ),
                            )}
                          </Grid>
                        </Card>
                      </Grid>
                    </Grid>
                  </Container>
                )}
              </div>
              {/* <Box style={{ marginTop: '1.5rem', padding: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#f8f9ff' }} sx={{
                py: "0.75rem",
                px: "1.25rem",
                backgroundColor: "#fff",
                padding: "0.75rem 1.25rem",
                borderTop: "0 solid rgba(79, 80, 98, 0.3)",
                "&:last-child": { borderRadius: "0 0 0.65rem 0.65rem" },
                "html[data-color-mode=\"dark\"] &": { backgroundColor: "#252525 !important", color: "rgba(255, 255, 255, 0.87)", borderColor: "rgba(255, 255, 255, 0.12) !important" },
              }}> */}
              <CardActions sx={{ mt: '0.5rem' }}>
                <Typography style={{ flex: 1 }} />
                {activeStep !== 0 && (
                  <Button
                    variant="contained"
                    onClick={handleBack}
                    sx={wizardPrimaryBtnSx}
                    >
                    Back
                  </Button>
                )}
                {activeStep !== 3 && (
                  <Button
                    variant="contained"
                    disabled={isDisabled}
                    onClick={handleNext}
                    sx={wizardPrimaryBtnSx}
                    >
                    Next
                  </Button>
                )}
                {activeStep === 3 && (
                  <Button
                    variant="contained"
                    type="submit"
                    onClick={contact}
                    sx={wizardPrimaryBtnSx}
                    >
                    Finish
                  </Button>
                )}
              </CardActions>
              {/* </Box> */}
            </span>
          </div>
        </Card>
      </ValidatorForm>
    </BlockUi>
  )
}

export default withSession(ContactAgentStepperComponent)
